import { readonly, ref } from 'vue';

/**
 * The right inset (px) the docked «Asistente» panel takes from the page;
 * 0 while it is hidden, an overlay or a sheet (plan §9.3). The panel writes
 * it together with the `--assistant-inset-right` CSS variable. Pinia-free on
 * purpose, so low-level primitives (`use-floating-panel.ts`) can read it.
 */
const inset = ref(0);

export const assistantInset = readonly(inset);

export function setAssistantInset(px: number): void {
  inset.value = Number.isFinite(px) && px > 0 ? px : 0;
}
